import { Icon, Link } from '@dev-spendesk/grapes';
import classNames from 'classnames';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

type Props = {
  downloadXmlUrl: string;
  className?: string;
};

export const DownloadEInvoiceXmlLink = ({
  downloadXmlUrl,
  className,
}: Props) => {
  const { t } = useTranslation('global');
  return (
    <div className={classNames('flex items-center gap-4 body-s', className)}>
      <Icon size="s" name="code-bracket" />
      {t('requests.panel.facturX')}
      <span className="text-content-disabled">|</span>
      <Link target="_blank" href={downloadXmlUrl}>
        {t('requests.panel.facturXTooltip')}
      </Link>
    </div>
  );
};
